import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source
            src="https://tristatewarriors.com/wp-content/uploads/2024/04/video-heathe-tristate-warrior-oficial-site.mov"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img
                src="https://tristatewarriors.com/wp-content/uploads/2024/02/Tristate-warriors.png"
                alt="Tri-State Warriors"
                className="h-16 w-16 object-contain"
              />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <a
                href="#home"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                HOME
              </a>
              <a
                href="#news"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                NEWS
              </a>
              <a
                href="#schedule"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                SCHEDULE
              </a>
              <a
                href="#team"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                TEAM
              </a>
              <a
                href="#about"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                ABOUT US
              </a>
              <a
                href="#tickets"
                className="bg-red-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                BUY TICKETS
              </a>
              <a
                href="#shop"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                SHOP
              </a>
              <a
                href="#contact"
                className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'
                }`}
              >
                CONTACT
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button className="lg:hidden text-white">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-4">
        <div className="text-center max-w-5xl mx-auto">
          <img
            src="https://tristatewarriors.com/wp-content/uploads/2024/02/test-1-1.png"
            alt="Tri-State Warriors"
            className="w-full max-w-4xl mx-auto mb-8"
          />
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight">
            NEW YORK'S PREMIER
            <br />
            WOMEN'S FOOTBALL TEAM
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-10 font-medium">
            Strength. Determination. Victory.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#join"
              className="bg-red-600 text-white px-10 py-4 rounded-lg text-lg font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              JOIN THE TEAM
            </a>
            <a
              href="#schedule"
              className="bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-lg text-lg font-bold hover:bg-white/20 transition-all border-2 border-white whitespace-nowrap cursor-pointer"
            >
              VIEW SCHEDULE
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </div>
  );
}
